module.exports = __webpack_public_path__ + "img/album07_16.e9bde4de.jpg";